import { ERepairTimeDivision } from "@tm/context-distribution"

export const calculateRawAwByDivision = (calculation: { value: number; division?: number }, tmDivision: ERepairTimeDivision): number => {
    const { value, division } = calculation
    return (value / (division || 1)) * tmDivision
}
